import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/(policies)/mentions-legales")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="max-container mt-10 mx-auto px-4 font-outfit">
      <h1 className="font-bold text-[#17365d] text-5xl max-md:text-2xl mb-5">
        Mentions Légales de HomeToq
      </h1>
      <hr className="h-0.5 bg-dark-blue rounded-full mb-5" />

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Éditeur du site</h2>
        <p>
          <strong>Raison sociale :</strong> HomeToq SAS <br />
          <strong>Statut juridique :</strong> Société par actions simplifiée
          (SAS) <br />
          <strong>Capital social :</strong> 10 000 euros <br />
          <strong>Adresse du siège social :</strong> 6 Rue des Potiers, 66240
          Saint-Estève, France <br />
          <strong>Numéro SIRET :</strong> 927 511 287 <br />
          <strong>Numéro TVA intracommunautaire :</strong> FR92927511287 <br />
          <strong>Email :</strong> contact@hometoq.com <br />
          <strong>Directeur de publication :</strong> M. Cameron Henri Chamorin
          (Président)
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Hébergement du site
        </h2>
        <p>
          <strong>Nom de l'hébergeur :</strong> Hostinger - VPS <br />
          <strong>Adresse :</strong> HOSTINGER INTERNATIONAL LTD, 61 Lordou
          Vironos Street, 6023 Larnaca, Chypre <br />
          <strong>Contact :</strong>{" "}
          <a
            href="https://www.hostinger.fr/contact"
            target="_blank"
            className="text-blue-600"
          >
            https://www.hostinger.fr/contact
          </a>{" "}
          <br />
          <strong>Site Web :</strong>{" "}
          <a
            href="https://www.hostinger.fr"
            target="_blank"
            className="text-blue-600"
          >
            https://www.hostinger.fr
          </a>{" "}
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Propriété intellectuelle
        </h2>
        <p>
          La structure générale du site www.hometoq.com, ainsi que les textes,
          graphiques, images, sons et vidéos qui le composent, sont la propriété
          de HomeToq SAS ou de ses partenaires. <br />
          Toute reproduction ou représentation, totale ou partielle, de ce site,
          par quelque procédé que ce soit, sans autorisation expresse de HomeToq
          SAS, est interdite.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Données personnelles
        </h2>
        <p>
          Conformément à la loi &laquo; Informatique et Libertés &raquo; du 6
          janvier 1978 modifiée et au Règlement Général sur la Protection des
          Données (RGPD), l&apos;Utilisateur dispose d&apos;un droit
          d&apos;accès, de rectification et de suppression des données
          personnelles le concernant. <br />
          Pour exercer ces droits, l&apos;Utilisateur peut envoyer un email à{" "}
          <a href="mailto:contact@hometoq.com" className="text-blue-600">
            contact@hometoq.com
          </a>
          .
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">
          Loi applicable et juridiction compétente
        </h2>
        <p>
          Les présentes mentions légales sont régies par le droit français.{" "}
          <br />
          En cas de litige, les tribunaux compétents de Perpignan seront seuls
          compétents.
        </p>
        <br />
        <br />
      </div>

      <div>
        <h2 className="text-[#356091] font-bold text-xl">Contact</h2>
        <p>
          Pour toute question, l&apos;Utilisateur peut contacter HomeToq à
          l&apos;adresse email{" "}
          <a href="mailto:contact@hometoq.com" className="text-blue-600">
            contact@hometoq.com
          </a>
          .
        </p>
      </div>
    </section>
  );
}
